module.exports = __webpack_public_path__ + "static/gallery-8a0a945b87527fd31053e1a560719f5d.jpg";